import userInfoStore from "@/store/user.store";
import UserAvatar from "../UserAvatar";
import IconEditUserName from "@/assets/common/ic_edit_userName.svg?react";
import { useRef } from "react";
import { IDisplayUserInfo, IUserInfo } from "@/types/user";
import UserEditModal, { UserEditModalRef } from "../UserEditModal";
import { defaultAvatarPrefix } from "@/utils/newAvatar";

interface IProps {
  disableEdit?: boolean;
  userInfo: IDisplayUserInfo;
}
const UserInfoMobile: React.FC<IProps> = ({ userInfo, disableEdit }) => {
  const { displayName, identityType, companyRealName } = userInfo;

  const userEditModalRef = useRef<UserEditModalRef>(null);

  const handleOpenEditModal = () => {
    if (disableEdit) return;
    userEditModalRef.current?.open();
  };

  const handleCallback = (newModel: IDisplayUserInfo) => {
    const { avatarUrl, avatarIndex, ...rest } = newModel;
    const formatNewModel: Partial<IUserInfo> = { ...rest };
    if (avatarUrl || avatarIndex) {
      formatNewModel.avatar =
        avatarUrl || `${defaultAvatarPrefix}${avatarIndex}`;
    }
    userInfoStore.getState().updateUserInfo(formatNewModel);
  };

  const name = identityType === 0 ? displayName : companyRealName;

  return (
    <div
      onClick={(e) => {
        e.stopPropagation();
      }}
    >
      <div
        className="py-6 flex flex-col items-center w-fit mx-auto"
        onClick={handleOpenEditModal}
      >
        <UserAvatar userInfo={userInfo} className="w-14 h-14 text-4.5 font-600" />
        <div className="flex items-center mt-3 h-9.5 font-500 text-5 text-mx-secondary relative">
          {name}
          {!disableEdit && <IconEditUserName className="absolute size-4 right--5" />}
        </div>
      </div>
      <UserEditModal
        ref={userEditModalRef}
        userInfo={userInfo}
        handleCallback={handleCallback}
      />
    </div>
  );
};

export default UserInfoMobile;